import React from 'react'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import agent from '../agent';
import {
    CATEGORY_UPDATE_PAGE_LOADED,
    CATEGORY_UPDATE_PAGE_UNLOADED,
    CATEGORY_UPDATE,
    CATEGORY_DELETE,
    REDIRECT
} from '../constants/actionTypes'
import Header from './widgets/Header'
import CrumbBox from './widgets/CrumbBox'
import { BASE_COIN_SYMBOL } from '../constants/config'
import Loading from './widgets/Loading'
import ListErrors from './ListErrors'
const mapStateToProps = state => ({
    ...state.settings,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: CATEGORY_UPDATE_PAGE_LOADED, payload }),
    onSubmit: (payload) => {
        dispatch({ type: CATEGORY_UPDATE, payload })
    },
    onUnload: () =>
        dispatch({ type: CATEGORY_UPDATE_PAGE_UNLOADED }),
    onDelete: (payload) =>
        dispatch({ type: CATEGORY_DELETE, payload }),
    onRedirect: () =>
        dispatch({ type: REDIRECT })
})

class CategoryEdit extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (name) => ev => {
            ev.preventDefault();
            const payload = agent.Categories.updateCategory(this.props.match.params.key, name)
            this.props.onSubmit(payload);
        }
        this.delete = () => ev => {
            ev.preventDefault()
            const payload = agent.Categories.deleteCategory(this.props.match.params.key)
            this.props.onDelete(payload)
        }
    }
    componentWillMount() {
        if (this.props.currentUser) {
            const payload = agent.Categories.getDetail(this.props.match.params.key)
            this.props.onLoad(payload);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.updated === true) {
            store.dispatch(push('/categories/manage'))
            this.props.onRedirect()
        }
        if (nextProps.category) {
            Object.assign(this.state, {
                name: nextProps.category.name,
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.category) {
            return (
                <Loading />
            )
        }
        const name = this.state.name;

        return (
            <div>
                <Header />
                <CrumbBox data={[{ key: 'Update Category' }]} rootKey='/settings' rootVal='Settings' />
                <div id="focus">
                    <div id="main">
                        <div id="main-wrap">
                            <div id="focus-wrap">
                                <h2>Update Category</h2>
                                <div className="FormItem">
                                    <label>Name</label>
                                    <input type="text"
                                        placeholder="Name"
                                        value={name}
                                        onChange={this.updateState('name')} />
                                </div>
                                <ListErrors errors={this.props.errors} />
                                <div className="FormItem">
                                    <button type="button" onClick={this.submitForm(name)} disabled={this.props.inProgress}>Update</button>
                                    <button type="button" onClick={this.delete()} disabled={this.props.inProgress}> Delete </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryEdit)
